import { mapGetters } from 'vuex';
import mvtListLinks from '@/common/components/mvtlistlinks/mvt-listlinks.vue';

export default {
  name: 'schoolsDistrictState',
  inject: ['$eventBus'],
  props: {
    data: {
        type: Object,
        default: {}
    }
  },
  components: {
     mvtListLinks
  },
  computed: {
    ...mapGetters('glb', ['viewport', 'glb'])
  }
};